export default "__VITE_ASSET__D3zf96mQ__"